<template>
  <div>
    <div class="">
      <page-header
        title="Shipping history"
        breadcrumb="Billings & Payments > My Transactions"
      />
    </div>

    <div class="bg-white p-3">
      <div class="flex py-4 justify-between flex-wrap">
        <div class="unit-point md:w-5/12 w-full">
          <p class="w-full">
            Transaction Count: {{ bookings.totalCount || 0 }}
          </p>
          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
        <div class="unit-point  md:w-5/12 w-full">
          <p class="w-full">
            Total Value: ₦ {{ amountFomatter(bookings.totalTransactionValue || 0) }}
          </p>
          <span class="w-12"
            ><img src="@/assets/images/billing/total_value.svg"
          /></span>
        </div>
      </div>
      <TableFilter @setSearchTerm = "sortSearchString" @filterProps="filterProps" @setQueryparams="sortItemProps" @appliedStatus="appliedStatus" :bookings="bookings.allShippings"  />
      <div v-loading="loading">
        <history-table :bookings="bookings.allShippings" />
      </div>
      <PaginationControl
        :total="bookings.totalCount"
        :pageNumber="pageNumber"
        @pageNumber="setPageDisplay"
        @pageSize="setNumDisplay"
      />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import HistoryTable from "./HistoryTable.vue";
import TableFilter from "./module/TableFilter.vue";
import PaginationControl from "@/components/UI/pagination";

export default {
  components: {
    PageHeader,
    HistoryTable,
    TableFilter,
    PaginationControl,
  },
  data() {
    return {
      bookings: {},
      loading: false,
      pageSize: 10,
      pageNumber: 1,
      sortOptions: {
        pageSize: 10,
        pageNumber: 1,
        interval: "month",
        startDate: "2025-02-25",
        endDate: "2025-02-25",
        searchString: "",
      },
    };
  },
  watch: {
    payload() {
      this.getBookingHistory();
    },
  },
  computed: {
    payload() {
      return {
        pageNumber: this.pageNumber,
        interval: this.sortOptions.interval,
        startDate: this.sortOptions.startDate,
        endDate: this.sortOptions.endDate,
        pageSize: this.pageSize,
        // searchTerm: "",
        shippingReference: "",
        customerType: "consumer",
        status: "history",
      };
    },
  },
  mounted() {
    this.getBookingHistory();
  },
  methods: {
     sortSearchString(val) {  
      if (val.length === 6 ) {
        this.payload.shippingReference = val  
        this.getBookingHistory();
      } else if (!val.length) {
        this.payload.shippingReference = ""  
        this.getBookingHistory();
      }
    },
    filterProps(val) { 
      this.sortOptions.interval = val   
      this.getBookingHistory();       
    },
    sortItemProps(val) {
      this.payload.interval = val.interval
      this.payload.startDate = val.startDate
      this.payload.endDate = val.endDate
      this.getBookingHistory(); 
    },
    
    appliedStatus(filteredVal) {
      this.bookings = filteredVal
    },
    setPageDisplay(val) {
      this.pageNumber = val;
    },
    setNumDisplay(val) {
      this.pageSize = val;
    },
    // sortItemProps(val) {
    //   this.sortOptions = { ...this.sortOptions, ...val };
    // },
    async getBookingHistory() {
      this.loading = true;
      try {
        await this.$_getShippingHistory(this.payload).then((response) => {
          this.bookings = response.data.data;
        });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },
  

  },
};
</script>

<style>
.unit-point {
  @apply flex items-center shadow-lg px-4 py-2 rounded-lg;
}
</style>
